// File: config - build-time environment (production vs preview)
// Created: 2026-09-28
// Updated: 2026-09-28
// Author: Erick Hernández Silva
//
// __CFG_ENV__ / __CFG_API_URL__ are injected at build time (rollup `replace`,
// vite `define`). Without them the bundle behaves as production.

/* global __CFG_ENV__, __CFG_API_URL__ */

export const PROD_API_URL = 'https://ibohqaerml.execute-api.us-east-2.amazonaws.com';

export const CONFIG_ENV = typeof __CFG_ENV__ !== 'undefined' && __CFG_ENV__ ? __CFG_ENV__ : 'production';

/** Preview = the dev stage: no leads/emails, share links stay on the preview page. */
export const IS_PREVIEW = CONFIG_ENV === 'preview';

export const API_URL = typeof __CFG_API_URL__ !== 'undefined' && __CFG_API_URL__ ? __CFG_API_URL__ : PROD_API_URL;
